import { Typography } from "antd";
import { Paths } from '../routes/path';
import { RESTRICTED_INTERN_USERID } from '../routes/routes';
import { useNavigate, useLocation } from 'react-router-dom';

// Assets
import logo from '../assests/logo.jpg';
import TabSlider from './TableSelector';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logoutUserAction } from "../store/actions/authActions";


function Header({ hideHeader = false }) {
	const dispatch = useDispatch();
	const { userData } = useSelector((state: any) => state.auth);
	const userRole = userData ? userData?.role === "admin" ? true : false : false;
	const isRestrictedIntern = userData?.userid?.startsWith(RESTRICTED_INTERN_USERID);


	// Menu Names
	const InitMenuItems = [
		{ name: "Home", link: Paths.Main },
		{ name: "Reports", link: Paths.Report },
		// Final Just uncomment!
		// { name: "Data", link: Paths.Data },

		// Temp - only for admin:
		...(userRole
		  ? [
			  { name: "Data", link: Paths.Data },
			]
		  : []
		),
		
		{ name: "Info", link: Paths.App },
	];

	const MenuItems = isRestrictedIntern
		? [
			{ name: "Cirium", link: Paths.CiriumScreen },
			{ name: "Logout", link: null },
		  ]
		: [
			...InitMenuItems,
			...(userRole
			  ? [
				  { name: "Admin", link: Paths.Admin },
				  { name: "Select Service", link: Paths.SelectService },
				]
			  : [{ name: "Account", link: Paths.Account }]
			),
			{ name: "Logout", link: null },
		  ];

	const title = "Digi Yatra Usage";
	const navigate = useNavigate(); // Initialize the navigation hook
	const location = useLocation(); // Access the current location (URL)

	const [Dummy, setDummy] = useState(0)

	useEffect(() => {
		setDummy(val => val + 1)
	}, [location])

	// Function to handle the menu item click
	const MenuOnClick = (item: string) => {
		if (item === "Logout") {
			logoutUserAction(dispatch)
			return
		}
		let navObject: any = MenuItems.find(val => val.name === item);
		if (navObject) {
			navigate(navObject.link);
		}
	}

	// Determine the index of the active path
	const activeIndex = MenuItems.findIndex(
		item => item?.link && location.pathname.startsWith(item.link)
	  );
	  
	return (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				marginTop: "5px",
				marginInline: "5px",
				backgroundColor: "rgb(59 130 246)",
				padding: '12px',
				borderRadius: '5px 27px',
				boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
			}}
		>
			<Typography.Title level={4} style={{ margin: 0, marginLeft: 20, color: "#FFF", fontWeight: "bold" }}>
				{title}
			</Typography.Title>

			{!hideHeader && <TabSlider key={Dummy} isMenu
				subcategories={MenuItems.map(val => val.name)}
				subCatOnClick={MenuOnClick}
				style={{ background: "#FFF" }}
				defaultTab={activeIndex >= 0 ? activeIndex : 0} // Default to the first tab if no match
			/>}

			<img
				src={logo}
				alt="CardImage"
				style={{
					width: 100,
					height: 30,
					scale: '1.5',
					objectFit: "contain",
					borderRadius: '2px 15px',
					background: 'white',
					marginRight: "17px"
				}}
			/>
		</div>
	);
}

export default Header;
